"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the Dataset landing page. Data repositories expose
 * no single keyless metadata API, so the tool opens straight on the manual-entry tab
 * preset to the "Dataset" source type (CSL `dataset`). Users type the creator, title,
 * repository, version, year, and DOI and pick any of the 10,834 styles — no engine change.
 */
export default function DatasetCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="dataset"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
